export { default as GDMDialogTitle } from './GDMDialogTitle';

export type { GDMDialogTitleComponent, GDMDialogTitleProps } from './GDMDialogTitle.type';
